import React from 'react'
import styled from 'styled-components'
import FillSlider, { FillSliderProps } from '~/components/FillSlider'

interface FillSliderCutProps {
  height?: number
  width?: number
  left?: number
  borderRadius?: number
  fillColor: string
  border?: string
  borderColor?: string
  outline?: string
  outlineColor?: string
}

const FillSliderCut = styled.div<FillSliderCutProps>`
  position: absolute;
  height: ${(props) => props.height ?? 24}px;
  width: ${(props) => props.width ?? 10}px;
  border-radius: ${(props) => props.borderRadius ?? 8}px;
  background-color: ${(props) => props.fillColor};
  border: ${(props) => props.border ?? ''};
  border-color: ${(props) => props.borderColor ?? ''};
  outline: ${(props) => props.outline ?? ''};
  outline-color: ${(props) => props.outlineColor ?? ''};
  top: 50%;
  left: ${(props) => props.left ?? 0}%;
  transform: translateY(-50%);
`

export interface FillSliderWithCutsProps
  extends Omit<FillSliderProps, 'children'> {
  cuts: number
  cutWidth?: number
  cutInterval?: number
  cutColor: string
  cutBorderRadius?: number
  cutBorderWidth?: number
  cutBorder?: string
  cutBorderColor?: string
  cutOutline?: string
  cutOutlineColor?: string
}

const FillSliderWithCuts = ({
  fillPercentage,
  fillColor,
  fillBorderRadius,
  fillBorder,
  fillBorderColor,
  fillOutline,
  fillOutlineColor,
  backgroundColor,
  borderRadius,
  border,
  borderColor,
  borderStyle,
  outline,
  outlineColor,
  height,
  width,
  margin,
  animate,
  animationDelay,
  animationTime,
  cuts,
  cutInterval,
  cutColor,
  cutWidth,
  cutBorderRadius,
  cutBorder,
  cutBorderColor,
  cutOutline,
  cutOutlineColor,
}: FillSliderWithCutsProps) => {
  const getCuts = () => {
    const jsx: React.ReactElement[] = []
    const actualWidth = cutWidth ?? 10
    const actualCutInterval = cutInterval ?? actualWidth / cuts

    for (let i = 1; i <= cuts; i++) {
      jsx.push(
        <FillSliderCut
          key={i}
          height={height}
          width={actualWidth}
          left={i * actualCutInterval}
          fillColor={cutColor}
          border={cutBorder ?? ''}
          borderRadius={cutBorderRadius ?? 0}
          borderColor={cutBorderColor ?? ''}
          outline={cutOutline ?? ''}
          outlineColor={cutOutlineColor ?? ''}
        />,
      )
    }
    return jsx
  }

  return (
    <FillSlider
      fillPercentage={fillPercentage}
      fillColor={fillColor}
      fillBorder={fillBorder}
      fillBorderColor={fillBorderColor}
      fillBorderRadius={fillBorderRadius}
      fillOutline={fillOutline}
      fillOutlineColor={fillOutlineColor}
      backgroundColor={backgroundColor}
      border={border}
      borderColor={borderColor}
      borderRadius={borderRadius}
      borderStyle={borderStyle}
      outline={outline}
      outlineColor={outlineColor}
      height={height}
      width={width}
      margin={margin}
      animate={animate}
      animationDelay={animationDelay}
      animationTime={animationTime}
    >
      {getCuts()}
    </FillSlider>
  )
}

export default FillSliderWithCuts
